import { QueryClient } from '@tanstack/react-query'

// Singleton instantiated at module load time — before React mounts.
// Imported directly by the router loader and by AppProviders,
// so both always reference the exact same cache instance.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      staleTime: 5 * 60 * 1000
    }
  }
})
